import { useMemo } from 'react';
import useShiftTypes from './useShiftTypes';
import type { DaySegment, ShiftType } from '@api/ShiftTypeService';

const getDaySegmentsByShiftCodes = (
    shiftTypes: ShiftType[],
): Record<string, DaySegment> =>
    Object.fromEntries(
        shiftTypes.map(({ code, daySegment }) => [code, daySegment]),
    );

const useDaySegmentsByShiftCodes = (): {
    daySegmentsByShiftCodes: Record<string, DaySegment> | undefined;
    shiftTypes: ShiftType[] | undefined;
    isLoadingShiftTypes: boolean;
} => {
    const { shiftTypes, isLoadingShiftTypes } = useShiftTypes();

    const daySegmentsByShiftCodes: Record<string, DaySegment> | undefined =
        useMemo(
            () =>
                shiftTypes ? getDaySegmentsByShiftCodes(shiftTypes) : undefined,
            [shiftTypes],
        );

    return { daySegmentsByShiftCodes, shiftTypes, isLoadingShiftTypes };
};

export default useDaySegmentsByShiftCodes;
